import styled from 'styled-components';

export const MobileTtsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
`;

export const MobileTtsControls = styled.div`
  display: flex;
  gap: 0.5rem;

  button {
    width: 100%;
    justify-content: center;
  }
`;

export const TtsTextbox = styled.textarea`
  display: flex;
  height: 100%;
  overflow-y: scroll;
  border: 2px dotted rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 8px;
  resize: none;
  background: ${({ theme }: {theme: any}) => theme.neutralLighter};
  color: ${({ theme }: {theme: any}) => theme.black};
`;

export const SpeakerModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 1rem 1rem;

  button.closeModal {
    position: absolute;
    top: 6px;
    right: 6px;
    border: none;
    background: none;
    color: ${({ theme }: {theme: any}) => theme.black};
    cursor: pointer;

    &:hover {
      color: ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }
`;

export const SpeakerModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 0.5rem;

  h1 {
    font: 700 1.2rem/1.3rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
  }

  h2 {
    text-align: center;
    font: 400 0.8rem/1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span {
    font: 700 0.7rem/1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.themeDark};
  }

  input {
    padding: 0 0.5rem;
    font: 300 0.8rem/1rem 'Roboto', sans-serif;
    height: 100%;
    border: 1px solid ${({ theme }: {theme: any}) => theme.white};
    color: ${({ theme }: {theme: any}) => theme.black};
    background-color: ${({ theme }: {theme: any}) => theme.neutralLighter};
    border-radius: 5px;

    &::placeholder {
      color: ${({ theme }: {theme: any}) => theme.black};
    }

    &:focus {
      border: 2px solid ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }
`;
